import { exitDemoMode } from "@/base/async-storage"
import { ENVIRONMENT, isTargetDatabase } from "@/base/environment"
import { prepareDemoEnvironmentAsync } from "@/base/farmhq-api"
import { handleReloadApp } from "@/base/utility"
import { useRequestHelpers } from "@/hooks/useRequestHelpers"
import type { ButtonProps, IconProp } from "@/theme"
import { Button } from "@/theme"
import React from "react"
import { useTranslation } from "react-i18next"

/**
 * Logic for
 */
export function usePrepareDemoButton() {
  const { t } = useTranslation("demoMode")
  const { dispatch, handleError, isLoading, toasts } = useRequestHelpers(
    "PrepareDemoEnvironment",
  )
  const targetDatabaseName = ENVIRONMENT.targetDatabaseName
  let text = t("loadDemoButton")
  if (!isTargetDatabase("PROD")) {
    text += ` (${targetDatabaseName})`
  }
  const IconComponent: IconProp = "Truck"
  return {
    IconComponent,
    isLoading,
    onPress: () => {
      dispatch(prepareDemoEnvironmentAsync())
        .unwrap()
        .then(() => toasts.success(t("toasts.isEnabled", { ns: "demoMode" })))
        .then(handleReloadApp)
        .catch((error) => {
          handleError(error, { toastMessage: "default" })
        })
    },
    text,
  }
}
export function PrepareDemoButton({
  ...props
}: ButtonProps): React.JSX.Element {
  const { IconComponent, isLoading, onPress, text } = usePrepareDemoButton()
  return (
    <Button
      {...props}
      IconComponent={IconComponent}
      isLoading={isLoading}
      text={text}
      onPress={onPress}
    />
  )
}

export function useExitDemoButton() {
  const { dispatch, handleError, isLoading } =
    useRequestHelpers("ExitDemoMode")
  const { t } = useTranslation()

  return {
    isLoading,
    onPress: () => {
      dispatch(exitDemoMode()).catch((error) => {
        handleError(error, { toastMessage: "default" })
      })
    },
    text: t("exitDemoButton", { ns: "demoMode" }),
  }
}
